"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _CheckmarkMedium = _interopRequireDefault(require("../../Icon/core/CheckmarkMedium"));

var _ChevronRightMedium = _interopRequireDefault(require("../../Icon/core/ChevronRightMedium"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = require("../../utils/icon");

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _events = require("../../utils/events");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _class, _class2, _temp;

var ListItem =
/**
 * An item in a list
 */
(0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ListItem, _Component);

  function ListItem() {
    (0, _classCallCheck2["default"])(this, ListItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ListItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(ListItem, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter(e) {
      if (this.props.onMouseEnter) {
        this.props.onMouseEnter(e);
      } else {
        e.currentTarget.focus();
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "onSelectFocused",
    value: function onSelectFocused(e) {
      e.preventDefault();

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.onSelect && !e.isPropagationStopped()) {
        this.props.onSelect(this.props.value, e);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this$props = this.props,
          onKeyDown = _this$props.onKeyDown,
          disabled = _this$props.disabled;

      if (onKeyDown) {
        onKeyDown(e);
      }

      if (!disabled) {
        _events.interpretKeyboardEvent.call(this, e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          icon = _this$props2.icon,
          label = _this$props2.label,
          className = _this$props2.className,
          children = _this$props2.children,
          selected = _this$props2.selected,
          disabled = _this$props2.disabled,
          focused = _this$props2.focused,
          hasNestedMenu = _this$props2.hasNestedMenu,
          _this$props2$tabIndex = _this$props2.tabIndex,
          tabIndex = _this$props2$tabIndex === void 0 ? 0 : _this$props2$tabIndex,
          _this$props2$role = _this$props2.role,
          role = _this$props2$role === void 0 ? 'option' : _this$props2$role,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["icon", "label", "className", "children", "selected", "disabled", "focused", "hasNestedMenu", "tabIndex", "role"]);
      delete otherProps.value;
      return (
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
        _react["default"].createElement("li", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
          className: (0, _classnames["default"])('spectrum-Menu-item', {
            'is-selected': selected,
            'is-disabled': disabled,
            'is-focused': focused
          }, className),
          onKeyDown: this.onKeyDown,
          onMouseEnter: disabled ? null : this.handleMouseEnter,
          onFocus: disabled ? null : this.handleFocus,
          onClick: disabled ? null : this.onSelectFocused,
          onBlur: this.handleBlur
          /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
          ,
          tabIndex: !disabled ? tabIndex : null,
          role: role,
          "aria-checked": role === 'menuitemcheckbox' || role === 'menuitemradio' ? !!selected : null,
          "aria-selected": role === 'option' ? !!selected || !!focused : null,
          "aria-disabled": disabled || null
        }), (0, _icon.cloneIcon)(icon, {
          size: 'S'
        }), _react["default"].createElement("span", {
          className: "spectrum-Menu-itemLabel"
        }, label || children), selected && _react["default"].createElement(_CheckmarkMedium["default"], {
          size: null,
          className: "spectrum-Menu-checkmark"
        }), hasNestedMenu && _react["default"].createElement(_ChevronRightMedium["default"], {
          className: "spectrum-Menu-chevron"
        }))
      );
    }
  }]);
  return ListItem;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /**
   * Whether or not the list item is selected
   */
  selected: _propTypes["default"].bool,

  /**
   * Whether or not  the list item is disabled
   */
  disabled: _propTypes["default"].bool,

  /**
   * Callback for when the list item is clicked
   */
  onClick: _propTypes["default"].func,

  /**
   * Callback for when the list item is selected
   */
  onSelect: _propTypes["default"].func,

  /**
   * The WAI-ARIA role for the list item. Defaults to "option", but could be "menuitem", "menuitemcheckbox", or "menuitemradio" depending on context.
   */
  role: _propTypes["default"].oneOf(['option', 'menuitem', 'menuitemcheckbox', 'menuitemradio'])
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  selected: false,
  disabled: false,
  onSelect: function onSelect() {},
  role: 'option'
}), _temp)) || _class;

exports["default"] = ListItem;